"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountdownTimer = void 0;
var countdown_timer_1 = require("./countdown-timer");
Object.defineProperty(exports, "CountdownTimer", { enumerable: true, get: function () { return countdown_timer_1.CountdownTimer; } });
